import React, { useState } from 'react';
import { Section, Image, TeslaText as Text, TeslaButton as Button, AccordionItem } from 'components';

import * as styles from './styles.module.scss';

const TwoColumnAccordiansGfv = (props) => {
  const { data } = props;
  const { primary, items } = data;
  const {
    title_large: titleLarge,
    btn_text: btnText,
    link,
    background_image: backgroundImage,
  } = primary;

  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  const hasCta = btnText?.text && link?.url;

  return (
    <Section sliceName="TwoColumnAccordiansGfv" noContainer className={styles.section}>
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <Text html={titleLarge?.html} text={titleLarge?.text} />
          {items.map((item, index) => (
            <AccordionItem
              key={item.title_small?.text || index}
              title={item.title_small}
              body={item.body1}
              index={index}
              isOpen={openIndex === index}
              onToggle={handleToggle}
            />
          ))}
          {hasCta && (
            <div className={styles.buttonContainer}>
              <Button to={link.url} theme="yellow">{btnText.text}</Button>
            </div>
          )}
        </div>
        {backgroundImage && (
          <div className={styles.imageContainer}>
            <Image image={backgroundImage} className={styles.image} />
          </div>
        )}
      </div>
    </Section>
  );
};

export default TwoColumnAccordiansGfv;
